import type { CSSProperties } from 'react'

import { Tooltip as ReactTooltip } from 'react-tooltip'

import Box from 'app/components/design-system-components/Box'
import { ToolTipQuestionMark } from 'app/components/design-system-components/ToolTipQuestionMark'

interface ToolTipProps {
  toolTipID: string
  content: JSX.Element | string
  icon?: JSX.Element
  hideQuestionMark?: boolean
  style?: CSSProperties
  className?: string
  ariaLabel?: string
}

interface TooltipIconProps {
  icon: JSX.Element
  toolTipID: string
}

const Icon = ({ icon, toolTipID }: TooltipIconProps) => {
  return (
    <Box data-tooltip-content="" data-tooltip-id={toolTipID}>
      {icon}
    </Box>
  )
}

export function ToolTip({
  toolTipID,
  content,
  icon,
  hideQuestionMark = false,
  className,
  ariaLabel,
}: ToolTipProps) {
  return (
    <Box zIndex="20" className={className}>
      {icon ? (
        <Icon icon={icon} toolTipID={toolTipID} />
      ) : (
        !hideQuestionMark && (
          <ToolTipQuestionMark
            toolTipID={toolTipID}
            {...(ariaLabel !== undefined && { ariaLabel })}
          />
        )
      )}

      <ReactTooltip id={toolTipID}>
        <Box maxWidth="275px" textAlign="center">
          <span>{content}</span>
        </Box>
      </ReactTooltip>
    </Box>
  )
}
